import axios from "axios";
import {getTenantHeader} from "../constants/globalfunc";

const setAccessToken = () => {
  const accessToken = localStorage.getItem("TOKEN") || null;
  const employee = JSON.parse(localStorage.getItem("USER")) || null;
  axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  axios.defaults.headers.common.apiCallerSource= `CHECKOUT`;
  axios.defaults.headers.common['RD-TenantID']= getTenantHeader();

  if (employee) {
    axios.defaults.headers.common.apiCallerId = employee?.employeeId;
  } else {
    delete axios.defaults.headers.common["apiCallerId"];
  }
};

const getAuthToken = () => {
  const hostname = window.location.hostname;
  const identifier = process.env.REACT_APP_IDENTIFIER || hostname.substring(0,hostname.indexOf(".")).toUpperCase();
  var creds = JSON.parse(process.env['REACT_APP_CREDS']);
  let clientId = creds[identifier]['USERNAME'];
  let secret = creds[identifier]['SECRET'];
  
  return axios.post(process.env.REACT_APP_BASE_URL + "api/auth/token", {
    clientId: clientId,
    secret: secret,
  });
}
const ISSERVER = typeof window === "undefined";
if (!ISSERVER) {
  setAccessToken();
}

export default {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  patch: axios.patch,
  setAccessToken,
  getAuthToken,
};
